import React from 'react';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import messages from '../../../../res/translations/messages';

class ChannelBox extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {modal: false};
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        const values = Object.assign({}, this.props.defaultValues, this.props.values, {enabled: e.target.checked});
        this.props.setFieldValue(`channels.${this.props.channel}`, values);
    }

    render() {
        const {channel, children, className, values} = this.props;
        const enabled = !!(values && values.enabled);
        return (
            <div className={classNames('survey-editor-item channel-box d-flex align-items-center', className)}>
                <div className="custom-control custom-checkbox flex-fill">
                    <input type="checkbox" checked={enabled} onChange={this.handleChange}
                        className="custom-control-input" id={`channels-${channel}-enabled`} />
                    <label className="custom-control-label" htmlFor={`channels-${channel}-enabled`}>
                        <FormattedMessage {...messages.channels[channel]} />
                    </label>
                </div>
                {children}
            </div>
        );
    }
}

export default ChannelBox;
